import React, { useState } from "react";
import "./RiskProfile.css";

const RiskProfile = ({ clientName, clientCode, filledDate, currentRisk }) => {
  const [step, setStep] = useState(1); // 1 = first page, 2 = second page
  const [selectedRisk, setSelectedRisk] = useState(""); // store user's choice
  const [riskProfile, setRiskProfile] = useState(currentRisk);


  // Move to next step
  const handleNext = () => {
    setStep(2);
  };

  // Go back to previous step
  const handleBack = () => {
    setStep(1);
    setSelectedRisk("");
  };

  // Handle Submit
  const handleSubmit = () => {
  if (selectedRisk) {
    setStep(1); // just go back
  } else {
    alert("Please select a risk profile!");
  }
};
 const handleNextDefault = () => {
    if (!selectedRisk) {
      setSelectedRisk("Moderate");
      setRiskProfile("Moderate");
    }
  };
  return (
    <div className="risk-page">
      <div className="risk-header">
        <h2>{clientName}</h2>
        <p>Client Code: {clientCode}</p>
      </div>

      {/* Step 1: Client Info Page */}
      {step === 1 && (
        <div className="risk-card">
          <p>
            Your Risk profile : {riskProfile} (As On {filledDate}) - (It is Self Declared)
          </p>
          {selectedRisk && (
  <div className="success-banner">
    Risk Profile Updated Successfully
  </div>
)}

          <p>
            Want to select your Risk Profile or complete a questionnaire to define it?
          </p>

          <div className="risk-actions">
            <button className="btn-outline" onClick={handleNext}>
              Change Pre-Defined Risk Profile
            </button>
            <button className="btn-red" onClick={handleNextDefault}>
  NEXT
</button>

          </div>
        </div>
      )}

      {/* Step 2: Select Risk Profile */}
      {step === 2 && (
        <div className="risk-card">
          <p>Please Select Self Declared Category</p>

          <div className="category-buttons">
            <button
              className={`btn-red ${selectedRisk === "Aggressive" ? "selected" : ""}`}
              onClick={() => {
  setSelectedRisk("Aggressive");
  setRiskProfile("Aggressive");
  setStep(1);
}}

            >
              Aggressive
            </button>
            <button
              className={`btn-red ${selectedRisk === "Conservative" ? "selected" : ""}`}
              onClick={() => {
  setSelectedRisk("Conservative");
  setRiskProfile("Conservative");
  setStep(1);
}}

            >
              Conservative
            </button>
            <button
              className={`btn-red ${selectedRisk === "Moderate" ? "selected" : ""}`}
              onClick={() => {
  setSelectedRisk("Moderate");
  setRiskProfile("Moderate");
  setStep(1);
}}
            >
              Moderate
            </button>
          </div>

          <div className="risk-actions">
            <button className="btn-outline" onClick={handleBack}>
              Back
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RiskProfile;
